/* Copyright 2021, Milkdown by Mirone. */
import { SupportedKeys as TableKeys } from '@milkdown/plugin-table';
import { SupportedKeys as CommonmarkKeys } from '@milkdown/preset-commonmark';
export const SupportedKeys = Object.assign(Object.assign(Object.assign({}, CommonmarkKeys), TableKeys), { StrikeThrough: 'StrikeThrough', TaskList: 'TaskList' });
//# sourceMappingURL=supported-keys.js.map